export const dateToInput = (v: string | null | undefined): string =>
  v ? v.substring(0, 10) : '';

export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;

export const getStatusBadge = (status: string | undefined): { text: string; color: string } => {
  switch (status) {
    case 'P': return { text: '已核准', color: '#52c41a' };
    case 'N': return { text: '未核准', color: '#faad14' };
    default: return { text: '未核准', color: '#d9d9d9' };
  }
};
